import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import LoggedLayout from '../../layouts/LoggedLayout';
import styled from 'styled-components';
import PageHeader from 'components/PageHeader';
import Paginator from 'components/Paginator';
import ThSortable from 'components/ThSortable';
import TrSkeleton from 'components/TrSkeleton';
import { default as ClockingsService } from 'services/Clockings';
import moment from 'moment';

const TableResponsive = styled.div` 
	@media (min-width: 992px) {
		overflow-x: visible;
	}
`;

const Table = styled.table`
	tr {
		cursor: pointer;
		
		th {

			&:nth-child(1) {
			}

			&:nth-child(2) {
				width: 20px;
			}
		}
	}
`;

export default function Dispensers(props) {
	const [queryParams] = useSearchParams();
    const navigate = useNavigate();

	const responsibleId = queryParams.get('responsible_id');

	let [dispensers, setDispensers] = useState([]);
	let [sortDirection, setSortDirection] = useState('desc');
	let [sortField, setSortField] = useState('full.name');
	let [skeletonRows, setSkeletonRows] = useState(5);
	let [page, _setPage] = useState(queryParams.get('page') ?? undefined);
	
	const setPage = (page) => {
		setDispensers({...dispensers, data: undefined});
		_setPage(page);
	}

	const sortTableClick = (field) => {
		if ( !field ) return;
		if ( field === sortField ) setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
		setSortField(field);
	};	

	useEffect(() => {
		let getDispensers = async () => {
			let dispensers = await ClockingsService.getDispensers({
				page: page,
				sort: sortField,
				direction: sortDirection,
				responsible_id: responsibleId
			});
			setSkeletonRows(dispensers?.length);
			setDispensers([...dispensers]);
		}
		getDispensers();
	}, [page, responsibleId, sortField, sortDirection]);

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<PageHeader style={{overflowX: 'visible', overflowY: 'visible'}}>
					<span className="header-column header-title">Expendedores</span>
					<span className="header-column header-icon-end">
						<i className="bi bi-file-spreadsheet text-plenoil-gray"></i>
					</span>
				</PageHeader>
			</div>

			<div className="col-md-12 mb-3">
				<div className="bg-white p-2 rounded shadow-sm">
					<div className="row">
						<div className="col-lg-10 align-content-center">
							<h4 className="mb-0">Listado de expendedores</h4>
						</div>
					</div>
				</div>
			</div>

			<div className="pt-2 col-md-12">
				<div className="px-0 col-lg pl-lg-0">
					<div className="row m-0 pb-2">
						<div className="col-12 px-0">
							<div className="h-100 p-4 background-color-blanco shadow rounded">
								<div className="table-responsive-rows">
									<div className="mvc-grid mvc-grid-header-mode">
										<div className="mvc-grid-table">
											<table>
												<thead>
													<tr>
														<ThSortable className="title_fichajes-expendedor" direction={sortDirection} active={sortField === 'user.name'} onClick={() => sortTableClick('user.name')}>Expendedor</ThSortable>
														{/* <ThSortable direction={sortDirection} active={sortField === 'has_alert'} onClick={() => sortTableClick('has_alert')}>Alerta</ThSortable> */}
													</tr>
												</thead>
												<tbody>
													{ dispensers?.map((el, idx) => {
														return (
															<React.Fragment key={el.id}>
																<tr onClick={() => navigate('/clockings/dispenser/' + el.id + '?schedule_day=' + moment().format('YYYY-MM-DD'))}>
																	<td className="title_fichajes-expendedor">{el.full_name}</td> 
																	{/* <td>
																		{el.has_alerts && <span className="text-danger"><i className="bi bi-asterisk"></i></span>}
																	</td> */}
																</tr>
															</React.Fragment>
														)
													}) }

													{ dispensers && !dispensers.length && <tr><td colSpan="100%">No hay datos disponibles</td></tr> }

													{ dispensers === undefined && <TrSkeleton rows={skeletonRows} columns={2} /> }
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* <div className="col-md-12 text-end mb-3">
				<div className="d-inline-block">
					<Paginator
						min={1}
						current={dispensers?.current_page}
						max={dispensers?.last_page}
						changeCallback={(page) => setPage(page)}
					/>
				</div>
			</div> */}
		</LoggedLayout>
	);
}